<template>
    <div class="home">
        <div class="back" @click="()=> this.$router.push('/home?meetingId='+ this.meetingId)">
            <span>返回首页</span> <button @click="quit">退出当前登录</button>
        </div>
        <div class="pc-back" @click="()=> this.$router.push('/home?meetingId='+ this.meetingId)">
           <span>&lt; 返回首页</span> <button @click="quit">退出当前登录</button>
        </div>
        <div class="banner">
            <img src="./static/avtor.png" alt="">
            <p>{{userinfo.contacts}}</p>
        </div>
        <div class="profile-wrapper">
            <div @click="goPage(item.url)" class="profile-item" v-for="(item, index) in profiles" :key="index">
                <img :src="item.imgurl" alt="">
                <p>{{item.title}}</p>
            </div>
        </div>
        <div class="pc-footer">

        </div>
    </div>
</template>
<script>
import http from '@/utils/http'
export default {
    data() {
        return {
           profiles: [
               {imgurl: require('./static/order.png'), title:'参会订单',url:'/ticket_order'},
               {imgurl: require('./static/user.png'), title:'个人信息',url:'/register?isedit=1'},
            //    {imgurl: require('./static/tickets.png'), title:'发票订单',url:'/invoice'},
            //    {imgurl: require('./static/hotel.png'), title:'住宿订单',url:'/order_list'}
           ],
           userinfo: {}
        }
    },
    methods:{
      goPage(url){
          this.$router.push(url)
      },
      async getInvoiceConfig() {
               const res = await http.get(`/renren-fast/app/audience/invoiceConfigInfo/${this.meetingId}`)
               const invoiceType = res.invoiceConfig.invoiceType.split('-')
               if(res.invoiceConfig.invoiceType){
                   this.profiles.push( {imgurl: require('./static/tickets.png'), title:'发票订单',url:'/invoice'} )
               }

              let meeting=JSON.parse(localStorage.getItem('meeting'))
               if(meeting.hotelStatus==1){
                  this.profiles.push( {imgurl: require('./static/hotel.png'), title:'住宿订单',url:'/order_list'} )              
             }
               


      },
      quit(){
          localStorage.removeItem('audienceId')
          localStorage.removeItem('audienceIdAndMeetingId')
          localStorage.removeItem('registerMobile')
          this.$router.push('/home?meetingId='+ this.meetingId)
      },
      async getUserInfo() {
          const params = {
              audienceId: localStorage.getItem('audienceId')
          }
          const res = await http.get(`/renren-fast/app/audienceCenter/getAudienceInfo/${this.meetingId}`, {params})
          if(res.code===0){
              console.log(res)
              this.userinfo = res.audience
          }
      }
    },
    computed:{
      // userinfo(){
      //    return JSON.parse(localStorage.getItem('userinfo')) || this.$store.state.userinfo
      // },
      meetingId() {
          return this.$store.state.meetingId || localStorage.getItem('meetingId')
      }
    },
    created() {
        this.getInvoiceConfig()
        this.getUserInfo()
    }
}
</script>
<style lang="stylus" scoped>
    .back
        padding 35px 22px 0
        background #fff
        font-size 28px
        color #606060
        display flex
        justify-content space-between
        align-items center
    .banner
        display flex
        justify-content center
        align-content center
        flex-wrap wrap
        height 336px
        background #fff
        img 
            width 165px
            height 165px
        p
            width 100%
            text-align center
            margin-top 36px
    .profile-wrapper
        display flex
        justify-content space-between
        align-items center
        flex-wrap wrap
        padding 10px 23px 0px
    .profile-item
        width 340px
        height 200px
        border-radius 20px
        background #fff
        display flex
        justify-content center
        align-content center
        flex-wrap wrap
        margin-top 24px
        img 
            width 83px
            height 71px
        p
            width 100%
            text-align center
            margin-top 27px
    .pc-back,.pc-footer
      display none
    @media screen and (min-width: 800px) 
      .back 
        display none
      .home 
        width: 900px;
        margin: 0 auto;
        min-height: 100vh;
        background: #fff;
        box-sizing: border-box;
        padding-bottom: 100px;
        .pc-back
            display flex
            justify-content space-between
            align-items center
            padding 46px
            background #fff
            font-size 20px
            color #606060
        .banner
            display flex
            justify-content flex-start
            align-items  center
            flex-wrap wrap
            height auto
            background #fff
            margin 0 14px
            padding 0 30px 30px
            border-bottom: 1px dashed #989898;
            img 
                width 125px
                height 125px
            p
                width auto
                text-align center
                margin-top 0
                margin-left 38px
                font-size 24px
                color: #262626;
        .profile-wrapper
            display flex
            justify-content space-between
            align-items center
            flex-wrap wrap
            padding 46px
        .profile-item
            width 252px
            height 246px
            border-radius 20px
            background #fff
            border: 1px solid #A4A4A4;
            display flex
            justify-content center
            align-content center
            flex-wrap wrap
            margin-top 24px
            img 
                width 83px
                height 71px
            p
                width 100%
                text-align center
                margin-top 27px
                font-size 20px
        .pc-footer
            display block
            width 100%
            height 150px
            background-color #373737


</style>